import React from 'react';
import { makeStyles, Snackbar, Grid, Typography, Button, Link } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    notificationWrap: {
        '& .MuiSnackbarContent-root': {
            width: 420,
        },
        '& .MuiLink-root': {
            display: 'flex',
            alignItems: 'center',
            fontWeight: 500,
        }
    },
    txtBody: {
        color: theme.palette.grey[400]
    }
}));

function DataPrivacyPolicyNotification () {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        if (!getCookie("policyConsent")) {
            setOpen(true)
        }
    },[])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        setCookie('policyConsent', 1, 365);
    }

    const setCookie = (key, value, expiryDays) => {
        const expires = new Date();
        expires.setTime(expires.getTime() + (expiryDays * 12 * 60 * 60 * 1000));
        document.cookie = key + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + '; path=/';
    }

    const getCookie = (key) => {
        const cookieArray = document.cookie.split(";");
        const keyValue = cookieArray.filter(item => item.split('=')[0].trim() === key);
        return keyValue.length ? decodeURIComponent(keyValue[0].split('=')[1]) : null;
    }

    return (
         <Snackbar
            className={classes.notificationWrap}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            open={open}
            onClose={handleClose}
            ContentProps={{
                'aria-describedby': 'policy-id'
            }}
            message={
                <Grid container spacing={2} id="policy-id">
                    <Grid item xs={12}>
                        <Typography variant="body2" align="center" className={classes.txtBody}>
                            We use cookies to give you the best experience on our website. By continuing without changing your cookie settings, we assume you agree to this.
                        </Typography>
                    </Grid>

                    <Grid container item xs={12} justify="space-evenly">
                        <Link rel="noopener" target="_blank" underline="always" color="secondary" href="https://www.interswitchgroup.com/ng/privacy-policy">
                            Read the Data Privacy Policy
                        </Link>
                        <Button color="inherit" className="btn" onClick={handleClose}>
                            I agree
                        </Button>
                    </Grid>
                </Grid>
            }
        />
    )
}

export default DataPrivacyPolicyNotification;
